import { useRecoilValue } from "recoil";
import { usersAtom } from "../miscellaneous/usersAtom";

export const useUsersValueDate = () => {
    const usersValue = useRecoilValue(usersAtom);

    return usersValue;
}
